window.addEventListener('DOMContentLoaded', () => {
	const complexCards = document.querySelectorAll('.complex-cards .card')

	complexCards.forEach(card => {
		let tab1Btn = card.querySelector('button.tab-1')
		let tab2Btn = card.querySelector('button.tab-2')
		let tab1 = card.querySelector('div.tab-1')
		let tab2 = card.querySelector('div.tab-2')
		let tab1Title = card.querySelector('.tab-1-title')
		let tab2Title = card.querySelector('.tab-2-title')

		tab1Btn.addEventListener('click', e => {
			tab2Btn.classList.remove('active')
			tab2.classList.remove('active')
			tab2Title.classList.remove('active')
			tab1Btn.classList.add('active')
			tab1.classList.add('active')
			tab1Title.classList.add('active')
		})

		tab2Btn.addEventListener('click', e => {
			tab1Btn.classList.remove('active')
			tab1.classList.remove('active')
			tab1Title.classList.remove('active')
			tab2Btn.classList.add('active')
			tab2.classList.add('active')
			tab2Title.classList.add('active')
		})
	})
})
